import React, { Component } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withSizes } from 'react-sizes';
import isEmpty from 'lodash/isEmpty';

import stores from '../../stores';
import { Map } from './Map';
import { BIG_SCREEN_CONTENT_WIDTH, MEDIUM_SCREEN_CONTENT_WIDTH } from '../../theme';
import media, { MOBILE, sizes } from '../../utils/mediaQueries';
import { MobileActions } from './MobileActions';
import { ExamCentersList } from './ExamCentersList';
import { withLoadingFallback } from '../../hocs/withLoadingFallback';
import { Filters } from './Filters';
import { adShape } from './propTypes';

const ExamCentersData = styled.div`
  height: 100%;
`;

const ExamCentersContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const MapContainer = styled.div`
  //to extend to the right border of the screen
  margin-right: calc(-1*(100vw - ${BIG_SCREEN_CONTENT_WIDTH}) /2);
  flex: 1;
  position: relative;
  
  @media screen and (max-width: 1199px) {
    margin-right: calc(-1*(100vw - ${MEDIUM_SCREEN_CONTENT_WIDTH}) /2);
  }
  
  ${media.mobile`
    display: none;
  `}
`;

const MapContainerInner = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  width: 100%;
`;

const ExamCentersDataWithLoadingFallback = withLoadingFallback(ExamCentersData);

class ExamCenterSearchClassComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mapObject: null,
    };
  }

  componentDidMount() {
    const {
      latitude, longitude, department, city, ads,
    } = this.props;

    stores.examCentersSearchStore.ads = ads;

    if (latitude) {
      stores.examCentersSearchStore.getExamCentersByCoordinates(latitude, longitude);
    } else if (department) {
      stores.examCentersSearchStore.getExamCentersByDepartmentAndCity(department, city);
    }
  }

  componentDidUpdate() {
    const { examCentersData } = stores.examCentersSearchStore;

    if (!isEmpty(examCentersData)) {
      const skeleton = document.querySelector('#react-skeleton');
      skeleton.style.display = 'none';
    }
  }

  setMapObject = (obj) => {
    this.setState({ mapObject: obj });
  };

  updateExamCentersByCoordinates = (latitude, longitude, radius) => {
    stores.examCentersSearchStore.getExamCentersByCoordinates(latitude, longitude, radius);
    stores.examCentersSearchStore.getAdsByCoordinates(latitude, longitude, radius);
  };

  updateExamCentersByDepartment = (department, city) => {
    stores.examCentersSearchStore.getExamCentersByDepartmentAndCity(department, city);
    stores.examCentersSearchStore.getAdsByDepartmentAndCity(department, city);
  };

  render() {
    const { sortedExamCenters, examCentersData } = stores.examCentersSearchStore;
    const {
      isMobile, latitude, longitude, ads,
    } = this.props;
    const { mapObject } = this.state;

    return (
      <ExamCentersDataWithLoadingFallback isLoading={isEmpty(examCentersData)} fallback={<div />}>
        {!isMobile && <Filters />}
        <div className="container">
          <ExamCentersContainer>
            <ExamCentersList
              examCentersData={sortedExamCenters}
              mapObject={mapObject}
              isMobile={isMobile}
              ads={ads}
            />
            {isMobile
              ? (
                <MobileActions
                  updateExamCentersByCoordinates={this.updateExamCentersByCoordinates}
                  examCentersData={sortedExamCenters}
                />
              )
              : (
                <MapContainer>
                  <MapContainerInner>
                    <Map
                      updateExamCentersByCoordinates={this.updateExamCentersByCoordinates}
                      examCentersData={sortedExamCenters}
                      setMapObject={this.setMapObject}
                      latitude={latitude || 49.023461463214126}
                      longitude={longitude || 3.44970703125}
                    />
                  </MapContainerInner>
                </MapContainer>
              )}
          </ExamCentersContainer>
        </div>
      </ExamCentersDataWithLoadingFallback>
    );
  }
}

ExamCenterSearchClassComponent.propTypes = {
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  department: PropTypes.string,
  city: PropTypes.string,
  isMobile: PropTypes.bool,
  ads: PropTypes.arrayOf(adShape),
};

ExamCenterSearchClassComponent.defaultProps = {
  latitude: null,
  longitude: null,
  department: null,
  city: null,
  isMobile: false,
  ads: [],
};

const ExamCenterSearch = observer(ExamCenterSearchClassComponent);

const mapSizesToProps = ({ width }) => ({
  isMobile: width < sizes[MOBILE],
});

const AdaptiveExamCenterSearch = withSizes(mapSizesToProps)(ExamCenterSearch);

export { AdaptiveExamCenterSearch };
